import React from 'react';
import { formatBytes } from '../../../Utils/GlobalUtils';
import FieldValTypography from '../../common/FieldValTypography';

function DownSizedBy({ artifactSize, sourceFileSize }) {
	const sizeDiff = sourceFileSize - artifactSize;
	return <FieldValTypography field="Size reduced by" val={formatBytes(sizeDiff)} />;
}

export default DownSizedBy;
